import React from 'react'
import BrandItem from './BrandItem'
import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'

const Brands = ({ label, data }) => {
    data.sort( (a,b) => a.Title.localeCompare(b.Title) )
    return (
        <section className="mb-8">
            <ResponsiveContainer>
                <h5 className="h5 text-optician-sans uppercase">{ label }</h5>
                <hr className="h-0 border-0 border-b border-solid border-white my-4" />
                <Swiper
                    
                    modules={[Autoplay]}
                    loop={ data.length < 8 ? false : true }
                    autoplay={ {
                        disableOnInteraction: false,
                        delay: 5000
                    } }
                    slidesPerView={2}
                    spaceBetween={32}
                    breakpoints={{
                        480: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 8
                        }
                    }}
                >
                    { data.map( (item, index) => {
                    return (
                        <SwiperSlide key={ index }>
                            <BrandItem title={ item.Title } url={ item.URL } imageObject={item.Logo.localFile} />
                        </SwiperSlide>
                    )
                    })}
                </Swiper>
            </ResponsiveContainer>
            
        </section>
    )
}

export default Brands
